import { render, staticRenderFns } from "./monetaryMultiAccountModal.vue?vue&type=template&id=2c1c2161&scoped=true&"
import script from "./monetaryMultiAccountModal.vue?vue&type=script&lang=js&"
export * from "./monetaryMultiAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c2161",
  null
  
)

export default component.exports